import appPackage from '../../package.json';

export const LEGACY_PROPOSAL_VERSION = '0.0.0';
// The CRM package version is the single source for current proposal,
// iframe callback, and rendered iframe documentation versions.
export const CURRENT_PROPOSAL_VERSION = appPackage.version;
export const IFRAME_RESPONSE_VERSION = CURRENT_PROPOSAL_VERSION;

const resolveIframeResponseVersion = (version) =>
  typeof version === 'string' && version.trim()
    ? version
    : IFRAME_RESPONSE_VERSION;

export const buildIframeResponse = (callbackType, data, version) => ({
  callbackType,
  data,
  version: resolveIframeResponseVersion(version),
});

export const postToParent = (
  callbackType,
  data,
  targetOrigin = '*',
  version
) => {
  if (!window.parent) return null;
  return window.parent.postMessage(
    buildIframeResponse(callbackType, data, version),
    targetOrigin
  );
};
